// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard-module__dashboardContainer {
  display: flex;
  padding: 24px 142px;
  background: linear-gradient(180deg, #f6fffc 0%, rgba(246, 255, 252, 0) 100%);
}

.Dashboard-module__mainContent {
  flex: 1;
  padding: 15px;
}

.Dashboard-module__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.Dashboard-module__title {
  display: flex;
  align-items: center;
  height: 100%;
  font-weight: 600;
  font-size: 20px;
  line-height: 130%;
  color: #263643;
  margin-bottom: 20px;
}

.Dashboard-module__searchContainer {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  width: 100%;
}

.Dashboard-module__inputContainer {
  display: flex;
  align-items: center;
  width: 448px;
  height: 44px;
  border-radius: 32px;
  border: 1px solid #bcbcbc;
  opacity: 1;
  padding: 0 20px;
}

.Dashboard-module__inputContainer input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  border-radius: 32px;
  color: #263643;
}
.Dashboard-module__inputContainer input::placeholder {
  font-size: 14px;
  font-weight: 600;
  line-height: 100%;
  color: #263643;
  opacity: 0.5;
}

.Dashboard-module__inputContainer img {
  width: 16px;
  height: 16px;
  margin-right: 16px;
}

.Dashboard-module__searchButtonContainer {
  display: flex;
  align-items: center;
  gap: 15px;
}

.Dashboard-module__searchButton {
  width: 115px;
  height: 44px;
  border-radius: 100px;
  padding: 14px 20px;
  opacity: 1;
  color: #ffffff;
  background-color: #324452;
  border: none;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 2px 4px rgba(50, 68, 82, 0.2);
}

.Dashboard-module__searchButton:hover {
  background-color: #263643;
  box-shadow: 0 4px 12px rgba(50, 68, 82, 0.3);
}

.Dashboard-module__searchButton:active {
  box-shadow: 0 1px 2px rgba(50, 68, 82, 0.2);
}

.Dashboard-module__evaluationGroupsListContainer {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.Dashboard-module__evaluationGroupsListActionsContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Dashboard-module__groupCount {
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #556575;
}

.Dashboard-module__evaluationGroupsListTable {
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px 0px #0000001a;
}

.Dashboard-module__evaluationGroupsListTable table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}

.Dashboard-module__evaluationGroupsListTable thead {
  background-color: #f3faff;
  padding: 20px 25px;
  height: 60px;
}

.Dashboard-module__evaluationGroupsListTable > table > thead > tr > th {
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  vertical-align: middle;
  color: #1e2a36;
}

.Dashboard-module__evaluationGroupsListTable > table > tbody > tr {
  background-color: #ffffff;
  height: 50px;
  border-bottom: 0.8px solid #e2e2e2;
  font-weight: 500;
  font-size: 12px;
  color: #263643;
  line-height: 150%;
  vertical-align: middle;
}

.Dashboard-module__evaluationGroupsListTable > table > tbody > tr:last-child {
  border-bottom: none;
}

.Dashboard-module__evaluationGroupsListTable th,
.Dashboard-module__evaluationGroupsListTable td {
  padding: 20px 25px;
  white-space: nowrap;
}

.Dashboard-module__evaluationGroupsListTable th {
  text-align: left;
}

.Dashboard-module__disabledTable {
  opacity: 0.7;
  transition: all 0.3s ease;
  pointer-events: none;
}

.Dashboard-module__evaluateButton {
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  vertical-align: middle;
  color: #3c8dcb;
  background: none;
  border: none;
  cursor: pointer;
}

.Dashboard-module__evaluationGroupsListTable > table > tbody > tr > td:last-child {
  text-align: right;
}

.Dashboard-module__groupNavigateButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: none;
  border: none;
  cursor: pointer;
}

.Dashboard-module__groupNavigateButton:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.Dashboard-module__groupNavigateButton img {
  width: 5px;
  height: 9px;
  display: block;
}
.Dashboard-module__unassignButton {
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  vertical-align: middle;
  color: #946200;
  background: none;
  border: none;
  cursor: pointer;
}
.Dashboard-module__assignedEvaluationTaskContainer {
  margin-top: 20px;
  margin-bottom: 20px;
}

.Dashboard-module__emptyMessage {
  padding: 40px 25px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #556575;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 20px 0px #0000001a;
}

.Dashboard-module__loadingMessage {
  padding: 40px 25px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #556575;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 20px 0px #0000001a;
}

.Dashboard-module__errorMessage {
  padding: 40px 25px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #ff3b30;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 20px 0px #0000001a;
}

.Dashboard-module__retryButton {
  margin-left: 8px;
  padding: 6px 16px;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: #ffffff;
  background-color: #324452;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-transform: uppercase;
}

.Dashboard-module__retryButton:hover {
  background-color: #263643;
}

.Dashboard-module__disabledMessage {
  padding: 12px 20px;
  margin-bottom: 16px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #946200;
  background-color: #fff8e1;
  border-radius: 8px;
  border: 1px solid #ffc107;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/Dashboard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,4DAA4D;EAC5D,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B","sourcesContent":[".dashboardContainer {\n  display: flex;\n  padding: 24px 142px;\n  background: linear-gradient(180deg, #f6fffc 0%, rgba(246, 255, 252, 0) 100%);\n}\n\n.mainContent {\n  flex: 1;\n  padding: 15px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.title {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 130%;\n  color: #263643;\n  margin-bottom: 20px;\n}\n\n.searchContainer {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.inputContainer {\n  display: flex;\n  align-items: center;\n  width: 448px;\n  height: 44px;\n  border-radius: 32px;\n  border: 1px solid #bcbcbc;\n  opacity: 1;\n  padding: 0 20px;\n}\n\n.inputContainer input {\n  width: 100%;\n  height: 100%;\n  border: none;\n  outline: none;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n  border-radius: 32px;\n  color: #263643;\n}\n.inputContainer input::placeholder {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 100%;\n  color: #263643;\n  opacity: 0.5;\n}\n\n.inputContainer img {\n  width: 16px;\n  height: 16px;\n  margin-right: 16px;\n}\n\n.searchButtonContainer {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.searchButton {\n  width: 115px;\n  height: 44px;\n  border-radius: 100px;\n  padding: 14px 20px;\n  opacity: 1;\n  color: #ffffff;\n  background-color: #324452;\n  border: none;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 100%;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: background-color 0.2s ease, box-shadow 0.2s ease;\n  box-shadow: 0 2px 4px rgba(50, 68, 82, 0.2);\n}\n\n.searchButton:hover {\n  background-color: #263643;\n  box-shadow: 0 4px 12px rgba(50, 68, 82, 0.3);\n}\n\n.searchButton:active {\n  box-shadow: 0 1px 2px rgba(50, 68, 82, 0.2);\n}\n\n.evaluationGroupsListContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.evaluationGroupsListActionsContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.groupCount {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: #556575;\n}\n\n.evaluationGroupsListTable {\n  width: 100%;\n  border-radius: 16px;\n  overflow: hidden;\n  background-color: #ffffff;\n  box-shadow: 0px 4px 20px 0px #0000001a;\n}\n\n.evaluationGroupsListTable table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  table-layout: fixed;\n}\n\n.evaluationGroupsListTable thead {\n  background-color: #f3faff;\n  padding: 20px 25px;\n  height: 60px;\n}\n\n.evaluationGroupsListTable > table > thead > tr > th {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n  vertical-align: middle;\n  color: #1e2a36;\n}\n\n.evaluationGroupsListTable > table > tbody > tr {\n  background-color: #ffffff;\n  height: 50px;\n  border-bottom: 0.8px solid #e2e2e2;\n  font-weight: 500;\n  font-size: 12px;\n  color: #263643;\n  line-height: 150%;\n  vertical-align: middle;\n}\n\n.evaluationGroupsListTable > table > tbody > tr:last-child {\n  border-bottom: none;\n}\n\n.evaluationGroupsListTable th,\n.evaluationGroupsListTable td {\n  padding: 20px 25px;\n  white-space: nowrap;\n}\n\n.evaluationGroupsListTable th {\n  text-align: left;\n}\n\n.disabledTable {\n  opacity: 0.7;\n  transition: all 0.3s ease;\n  pointer-events: none;\n}\n\n.evaluateButton {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 150%;\n  vertical-align: middle;\n  color: #3c8dcb;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.evaluationGroupsListTable > table > tbody > tr > td:last-child {\n  text-align: right;\n}\n\n.groupNavigateButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.groupNavigateButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.groupNavigateButton img {\n  width: 5px;\n  height: 9px;\n  display: block;\n}\n.unassignButton {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 150%;\n  vertical-align: middle;\n  color: #946200;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n.assignedEvaluationTaskContainer {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.emptyMessage {\n  padding: 40px 25px;\n  text-align: center;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n  color: #556575;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0px 4px 20px 0px #0000001a;\n}\n\n.loadingMessage {\n  padding: 40px 25px;\n  text-align: center;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n  color: #556575;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0px 4px 20px 0px #0000001a;\n}\n\n.errorMessage {\n  padding: 40px 25px;\n  text-align: center;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n  color: #ff3b30;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0px 4px 20px 0px #0000001a;\n}\n\n.retryButton {\n  margin-left: 8px;\n  padding: 6px 16px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n  color: #ffffff;\n  background-color: #324452;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  text-transform: uppercase;\n}\n\n.retryButton:hover {\n  background-color: #263643;\n}\n\n.disabledMessage {\n  padding: 12px 20px;\n  margin-bottom: 16px;\n  text-align: center;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n  color: #946200;\n  background-color: #fff8e1;\n  border-radius: 8px;\n  border: 1px solid #ffc107;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboardContainer": `Dashboard-module__dashboardContainer`,
	"mainContent": `Dashboard-module__mainContent`,
	"header": `Dashboard-module__header`,
	"title": `Dashboard-module__title`,
	"searchContainer": `Dashboard-module__searchContainer`,
	"inputContainer": `Dashboard-module__inputContainer`,
	"searchButtonContainer": `Dashboard-module__searchButtonContainer`,
	"searchButton": `Dashboard-module__searchButton`,
	"evaluationGroupsListContainer": `Dashboard-module__evaluationGroupsListContainer`,
	"evaluationGroupsListActionsContainer": `Dashboard-module__evaluationGroupsListActionsContainer`,
	"groupCount": `Dashboard-module__groupCount`,
	"evaluationGroupsListTable": `Dashboard-module__evaluationGroupsListTable`,
	"disabledTable": `Dashboard-module__disabledTable`,
	"evaluateButton": `Dashboard-module__evaluateButton`,
	"groupNavigateButton": `Dashboard-module__groupNavigateButton`,
	"unassignButton": `Dashboard-module__unassignButton`,
	"assignedEvaluationTaskContainer": `Dashboard-module__assignedEvaluationTaskContainer`,
	"emptyMessage": `Dashboard-module__emptyMessage`,
	"loadingMessage": `Dashboard-module__loadingMessage`,
	"errorMessage": `Dashboard-module__errorMessage`,
	"retryButton": `Dashboard-module__retryButton`,
	"disabledMessage": `Dashboard-module__disabledMessage`
};
export default ___CSS_LOADER_EXPORT___;
